import {
  InstalledEvse,
  ProvisionedEvse,
  OrchestrationInfo,
  EvseSelfOnboardingDetails,
} from "src/models/smartChargingClientsModels";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Text from "src/components/Displays/Text";
import { SESSION_KEYS } from "src/consts/session";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import { Box, List, Stack, Divider, ListItem } from "@mui/material";
import { SMART_CHARGING_ROUTES } from "src/consts/Paths/SmartCharging";
import EvseListItem from "src/components/SmartCharging/Components/EvseListItem";

const OverviewStart = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("translation");

  const [getOrchestrationInfo] = useSessionStorage<OrchestrationInfo>(
    SESSION_KEYS.ORCHESTRATION_INFO,
  );
  const installedEvses = getOrchestrationInfo()?.installedEvses ?? [];
  const provisionedEvses = getOrchestrationInfo()?.provisionedEvses ?? [];

  const [, setEvseSelfOnboardingData] =
    useSessionStorage<EvseSelfOnboardingDetails>(
      SESSION_KEYS.EVSE_SELF_ONBOARDING_DETAILS,
    );

  const handleinstalledEvseClick = (evse: InstalledEvse) => {
    return `${navigate(SMART_CHARGING_ROUTES.OVERVIEW_DETAILS + `?evse=${evse.uuid}`)}`;
  };

  const handleProvisionedEvseClick = (evse: ProvisionedEvse) => {
    setEvseSelfOnboardingData(evse);
    return `${navigate(SMART_CHARGING_ROUTES.ADD_WALLBOX_START)}`;
  };

  const handleCompCheckClick = () => {
    navigate(SMART_CHARGING_ROUTES.COMPATIBILITY);
  };

  return (
    <Stack gap={5}>
      <Stack gap={5}>
        <Text
          text={t("page.overviewStart.pageTitle")}
          sx={(theme) => ({
            fontWeight: 500,
            fontSize: "32px",
            lineHeight: "40px",
            fontFamily: "officina",
            color: theme.palette.mainFont.primary,
          })}
        />

        <Text
          text={t("page.overviewStart.pageSubTitle")}
          sx={(theme) => ({
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "20px",
            fontFamily: "Inter",
            color: theme.palette.mainFont.primary,
          })}
        />
      </Stack>

      <Stack gap={5}>
        <Text
          text={t("page.overviewStart.listTitle1")}
          sx={(theme) => ({
            fontSize: "24px",
            fontWeight: "500",
            lineHeight: "28px",
            fontFamily: "officina",
            color: theme.palette.mainFont.primary,
          })}
        />

        <Box
          sx={(theme) => ({
            px: "16px",
            borderRadius: "12px",
            bgcolor: theme.palette.white.main,
          })}
        >
          <List>
            {installedEvses && installedEvses.length === 0 && (
              <Text
                text={"n.a."}
                sx={(theme) => ({
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "20px",
                  fontFamily: "Inter",
                  textAlign: "center",
                  color: theme.palette.mainFont.primary,
                })}
              />
            )}
            {installedEvses &&
              installedEvses.map((evse, index) => (
                <>
                  <EvseListItem
                    itemText={`${evse.manufacturer} ${evse.model}`}
                    handleItemClick={() => handleinstalledEvseClick(evse)}
                  />
                  {installedEvses.length !== index + 1 && (
                    <Divider sx={{ ml: "16px", mr: "16px" }} />
                  )}
                </>
              ))}
            <ListItem disablePadding></ListItem>
          </List>
        </Box>
      </Stack>

      <Stack gap={2}>
        <Text
          text={t("page.overviewStart.listTitle2")}
          sx={(theme) => ({
            fontSize: "24px",
            fontWeight: "500",
            lineHeight: "28px",
            fontFamily: "officina",
            color: theme.palette.mainFont.primary,
          })}
        />

        <Box
          sx={(theme) => ({
            px: "16px",
            borderRadius: "12px",
            bgcolor: theme.palette.white.main,
          })}
        >
          <List>
            {provisionedEvses && provisionedEvses.length === 0 && (
              <Text
                text={"n.a."}
                sx={(theme) => ({
                  fontSize: "14px",
                  fontWeight: "400",
                  lineHeight: "20px",
                  fontFamily: "Inter",
                  textAlign: "center",
                  color: theme.palette.mainFont.primary,
                })}
              />
            )}

            {provisionedEvses &&
              provisionedEvses.map((evse, index) => (
                <>
                  <EvseListItem
                    itemText={`${evse.manufacturer} ${evse.modelName}`}
                    handleItemClick={() => handleProvisionedEvseClick(evse)}
                  />
                  {provisionedEvses.length !== index + 1 && (
                    <Divider sx={{ ml: "16px", mr: "16px" }} />
                  )}
                </>
              ))}
            <ListItem disablePadding></ListItem>
          </List>
        </Box>
      </Stack>

      <Box>
        <PrimaryButton
          onClick={handleCompCheckClick}
          text={t("page.overviewStart.button")}
          sx={{
            border: "1px solid #00000038",
            backgroundColor: "transparent",
            color: "#3B3B3B",
          }}
        />
      </Box>
    </Stack>
  );
};

export default OverviewStart;
